import CollectionApi from 'client/api/v2/CollectionApi';

export default new class SupportCaseApi extends CollectionApi {
  constructor() {
    super('/api/v2/organizations/cases', {
      skip: 0,
      limit: 50,
      filter: [{
        name: 'search',
        operator: 'search',
        value: '',
      }],
    });
  }

  async fetch(...args) {
    const result = await super.fetch(...args);

    return {
      ...result,
      results: result.results.map(item => ({
        ...item,
        // needed to avoid ItemListPagination bug
        id: item.caseNumber,
      })),
    };
  }
}();
